import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompany } from '../context/CompanyContext';
import { api } from '../services/api';
import './Onboarding.css';

const STEPS = ['Welcome','Company','Modules','Launch'];

const MODULES = [
  { id:'crm',      icon:'👤', label:'CRM + Leads',        desc:'Manage leads, pipeline, clients' },
  { id:'hr',       icon:'👥', label:'HR + Attendance',     desc:'Team, attendance, leave, salary' },
  { id:'finance',  icon:'💰', label:'Finance + Billing',   desc:'Invoices, expenses, reports' },
  { id:'projects', icon:'📋', label:'Projects + Kanban',   desc:'Tasks, boards, timelines' },
  { id:'analytics',icon:'📊', label:'Analytics',           desc:'Reports, charts, globe map' },
  { id:'calendar', icon:'📅', label:'Calendar',            desc:'Events, follow-ups, reminders' },
];

export default function Onboarding() {
  const navigate  = useNavigate();
  const { update } = useCompany();
  const [step, setStep]       = useState(0);
  const [saving, setSaving]   = useState(false);
  const [modules, setModules] = useState(['crm','hr','finance']);
  const [company, setCompany] = useState({
    name:'', tagline:'', email:'', phone:'', website:'', gstin:'', address:'', city:'', state:'', pincode:''
  });

  const setCo = (k,v) => setCompany(p=>({...p,[k]:v}));
  const toggleModule = (id) => setModules(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);

  const finish = async () => {
    setSaving(true);
    try {
      if (company.name) { await api.saveCompany(company); update(company); }
    } catch(e) {}
    navigate('/dashboard');
  };

  return (
    <div className="ob-wrap">
      <div className="ob-progress">
        {STEPS.map((s,i) => <div key={s} className={`ob-dot${i===step?' active':i<step?' done':''}`}/>)}
      </div>

      {step === 0 && (
        <div className="ob-card">
          <div className="ob-emoji">🚀</div>
          <div className="ob-title">Welcome to RyzenOS</div>
          <div className="ob-sub">Your business command center. Let's set things up in 2 minutes.</div>
          <button className="ob-btn" onClick={()=>setStep(1)}>Get started →</button>
        </div>
      )}

      {step === 1 && (
        <div className="ob-card ob-wide">
          <div className="ob-label">COMPANY PROFILE</div>
          <div className="ob-title">Tell us about your company</div>
          <div className="ob-fields">
            <div className="ob-row">
              <div className="ob-grp"><label className="ob-lbl">Company name *</label><input className="ob-inp" placeholder="Enter your company name" value={company.name} onChange={e=>setCo('name',e.target.value)}/></div>
              <div className="ob-grp"><label className="ob-lbl">Tagline</label><input className="ob-inp" placeholder="What you do in one line" value={company.tagline} onChange={e=>setCo('tagline',e.target.value)}/></div>
            </div>
            <div className="ob-row">
              <div className="ob-grp"><label className="ob-lbl">Business email *</label><input className="ob-inp" type="email" placeholder="hello@yourcompany.com" value={company.email} onChange={e=>setCo('email',e.target.value)}/></div>
              <div className="ob-grp"><label className="ob-lbl">Phone *</label><input className="ob-inp" placeholder="+91 XXXXX XXXXX" value={company.phone} onChange={e=>setCo('phone',e.target.value)}/></div>
            </div>
            <div className="ob-row">
              <div className="ob-grp"><label className="ob-lbl">GSTIN</label><input className="ob-inp" placeholder="Your GST number" value={company.gstin} onChange={e=>setCo('gstin',e.target.value)}/></div>
              <div className="ob-grp"><label className="ob-lbl">Website</label><input className="ob-inp" placeholder="www.yourcompany.com" value={company.website} onChange={e=>setCo('website',e.target.value)}/></div>
            </div>
            <div className="ob-grp ob-full"><label className="ob-lbl">Address</label><input className="ob-inp" placeholder="Street address, building number" value={company.address} onChange={e=>setCo('address',e.target.value)}/></div>
            <div className="ob-row">
              <div className="ob-grp"><label className="ob-lbl">City</label><input className="ob-inp" placeholder="City" value={company.city} onChange={e=>setCo('city',e.target.value)}/></div>
              <div className="ob-grp"><label className="ob-lbl">State</label><input className="ob-inp" placeholder="State" value={company.state} onChange={e=>setCo('state',e.target.value)}/></div>
              <div className="ob-grp"><label className="ob-lbl">Pincode</label><input className="ob-inp" placeholder="000000" value={company.pincode} onChange={e=>setCo('pincode',e.target.value)}/></div>
            </div>
          </div>
          <div className="ob-btns">
            <button className="ob-btn-sec" onClick={()=>setStep(0)}>Back</button>
            <button className="ob-btn" onClick={()=>setStep(2)}>Continue →</button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="ob-card ob-wide">
          <div className="ob-label">MODULES</div>
          <div className="ob-title">What do you need?</div>
          <div className="ob-sub">Select the modules to activate. You can change this anytime in Settings.</div>
          <div className="ob-modules">
            {MODULES.map(m => (
              <div key={m.id} className={`ob-module${modules.includes(m.id)?' active':''}`} onClick={()=>toggleModule(m.id)}>
                <span className="ob-module-icon">{m.icon}</span>
                <div><div className="ob-module-label">{m.label}</div><div className="ob-module-desc">{m.desc}</div></div>
                {modules.includes(m.id) && <div className="ob-module-check">✓</div>}
              </div>
            ))}
          </div>
          <div className="ob-btns">
            <button className="ob-btn-sec" onClick={()=>setStep(1)}>Back</button>
            <button className="ob-btn" onClick={()=>setStep(3)}>Continue →</button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="ob-card">
          <div className="ob-emoji">🎉</div>
          <div className="ob-title">You're all set!</div>
          <div className="ob-sub">RyzenOS is ready. {company.name && `Welcome, ${company.name}!`}</div>
          <div className="ob-summary">
            <div className="ob-sum-item">✓ {modules.length} modules activated</div>
            {company.name && <div className="ob-sum-item">✓ Company profile saved</div>}
            <div className="ob-sum-item">✓ Your team can now login</div>
          </div>
          <button className="ob-btn" onClick={finish} disabled={saving}>
            {saving ? 'Setting up…' : 'Go to Dashboard →'}
          </button>
        </div>
      )}
    </div>
  );
}
